const CharacterTokenizer = require("./characterTokenizer");
class CloseParenthesis extends CharacterTokenizer{
    constructor(){
        super("parenthesis", ")");
    }
}

module.exports = CloseParenthesis;